import { useState } from 'react';
import {getStorageItem, setStorageItem} from "./localStorageService";

export function useStorageState(fieldName, initialValue) {
    const [value, setValueState] = useState(initialValue);

    const getValue = ()=> {
        if (value != null) return value;

        try {
            const val = getStorageItem(fieldName);

            if (val === '{}' || val == null) {
                return undefined;
            }

            const getVal = JSON.parse(val);
            setValueState(getVal);
            return getVal;
        } catch {
            return undefined;
        }
    };

    const setValue = (val) => {
        if (val === undefined) {
            setValueState(undefined);
            setStorageItem(fieldName, '{}');
            return;
        }

        const valJson = JSON.stringify(val);
        setStorageItem(fieldName, valJson);
        setValueState(val);
    };

    return [getValue(), setValue];
}
